import { getSum } from '@/utils/index'

export interface FinanceOverviewIncome {
    sales_income: number | string
    recharge_amount: number | string
    consume_amount: number | string
    online_sales_income?: number | string
    online_recharge_amount?: number | string
    online_consume_amount?: number | string
    balance_refund_amount?: number | string
}

function getAmount(value?: number | string): number {
    return value == null || value === '' ? 0 : +value
}

/**
 * PC 数据概览与零售通保持同一总收款口径：
 * 线下总收款 + 线上总收款 - 会员余额退款。
 */
export function getFinanceOverviewTotalIncome(row: FinanceOverviewIncome): number {
    return getSum(
        getAmount(row.sales_income),
        getAmount(row.recharge_amount),
        -getAmount(row.consume_amount),
        getAmount(row.online_sales_income),
        getAmount(row.online_recharge_amount),
        -getAmount(row.online_consume_amount),
        -getAmount(row.balance_refund_amount)
    )
}
